// User helper

/**
 * Get the user avatar image path
 * 
 * @param {int} userId the user id 
 * @param {string} avatar the avatar image
 * 
 * @returns {string} the user's avatar image path
 */
export const getAvatarUrl = (path) => {
    return import.meta.env.VITE_API_URL + 'avatar/'+ path;
};

export const getUserAvatar = (user) => {
    return (
        <div className="user-avatar-wrap">
            {user?.profile_photo_path
                ? <img className="avatar" src={getAvatarUrl(user.profile_photo_path)} />

                : <div className="avatar-placeholder">
                    <i className="pi pi-user"></i>
                </div>
            }
        </div>
    );
};